import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(0),
      //   width: '28ch',
      },
    },
  }));

function LeverantorKundList(props) {
    const classes = useStyles();
    const AktivaKunder = useSelector(state=>state.accountsData.AktivaKunder)
    const [businessType, setBusinessType] = React.useState(props.leverantorKund);
    React.useEffect(()=>{
        setBusinessType(props.leverantorKund)
    },[props.leverantorKund])
    return (
        <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          variant="outlined"
          fullWidth
          label={<IntlMessages id="input.Connect.Supplier"/>}
          size="small"
          name="leverantorKund"
          select
          value={businessType}
          onChange={props.onChangeA}
          margin="normal"
          SelectProps={{
            native: true,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          <option value=""><IntlMessages id="Choose"/></option>
          {
            AktivaKunder.filter(item=>{
                return parseInt(item.isleverantor) === 1
            }).map(item=>{
                return <option value={item.Orgnr}>{item.AF_kundnamn}</option>
            })
          }
        </TextField>
      </div>
      </form>
    );
}

export default LeverantorKundList;